export default "__VITE_ASSET__CxkW8xnQ__"